import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-iframe',
  templateUrl: './Iframe.component.html',
  styleUrls: ['./Iframe.component.scss']
})
export class IframeComponent implements OnInit {
  @Input() targetUrl: string;
  @Output() closeFrame: EventEmitter<boolean> = new EventEmitter();

  public iframeSrc: SafeUrl = '';
  public doc: any;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    // Trust the given URL and treat it as safe
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.targetUrl);
  }

  public onLoad(iframe) {
    this.doc = iframe.contentWindow;
  }

  public goBack() {
    this.doc.history.back(-1);
  }

  public close() {
    this.closeFrame.emit(true);
  }

}
